import { render, staticRenderFns } from "./DateAndItemPicker.vue?vue&type=template&id=5e4becf0&scoped=true&"
import script from "./DateAndItemPicker.vue?vue&type=script&lang=js&"
export * from "./DateAndItemPicker.vue?vue&type=script&lang=js&"
import style0 from "./DateAndItemPicker.vue?vue&type=style&index=0&id=5e4becf0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4becf0",
  null
  
)

export default component.exports